import { render, staticRenderFns } from "./Battles.vue?vue&type=template&id=90b1bb26&"
import script from "./Battles.vue?vue&type=script&lang=js&"
export * from "./Battles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports